import React, { createContext, useCallback, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ShopGroup from '../entities/shop-group.entity';

interface ShopGroupContextProps {
  shopGroup: ShopGroup | null;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setShopGroup: React.Dispatch<React.SetStateAction<ShopGroup | null>>;
  handleSelectShopGroup: (newShopGroup: ShopGroup) => void;
  handleUnselectShopGroup: () => void;
}

export const ShopGroupContext = createContext<ShopGroupContextProps>({} as ShopGroupContextProps);

export const useShopGroupsContext = () => useContext(ShopGroupContext);

export const ShopGroupProvider = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [shopGroup, setShopGroup] = useState<ShopGroup | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSelectShopGroup = useCallback(
    (newShopGroup: ShopGroup) => {
      setShopGroup(newShopGroup);
      navigate(`/shop-groups/${newShopGroup.id}`);
    },
    [navigate]
  );

  const handleUnselectShopGroup = useCallback(() => {
    setShopGroup(null);
    navigate('/shop-groups');
  }, [navigate]);

  return (
    <ShopGroupContext.Provider
      value={{ shopGroup, loading, setLoading, setShopGroup, handleSelectShopGroup, handleUnselectShopGroup }}
    >
      {children}
    </ShopGroupContext.Provider>
  );
};
